'use client';

import { Fragment } from 'react';
import { BannerWithCta } from '../BannerWithCta';
import { HeaderDesktopMenuDrawerProps, HeaderDesktopMenuLinkProps } from '../HeaderDesktopMenu';
import HeaderMobileTakeover, {
  HeaderMobileLinkProps,
  HeaderMobileMenuDrawerProps,
  MobileMenuLinkProps,
} from '../HeaderMobileTakeover';
import { CenterMenuColumn } from './CenterMenuColumn';
import { DesktopHeader } from './DesktopHeader';
import { useHeader } from './Header.hooks';
import { DesktopMenuLink } from './Header.types';
import { LogoColumn } from './LogoColumn';
import { RightMenuColumn } from './RightMenuColumn';

export type HeaderProps = {
  invert?: boolean;
  forceOpaque?: boolean;
  promoBanner?: React.ReactNode;
  desktopMenu: (HeaderDesktopMenuDrawerProps | HeaderDesktopMenuLinkProps)[];
  desktopMenuLinks: DesktopMenuLink[];
  mobileMenu: (HeaderMobileMenuDrawerProps | HeaderMobileLinkProps)[];
  mobileMenuLinks: MobileMenuLinkProps[];
  hasGlobalBanner?: boolean;
}

const Header = ({
  invert,
  promoBanner,
  forceOpaque,
  desktopMenu = [],
  desktopMenuLinks = [],
  mobileMenu = [],
  mobileMenuLinks = [],
  hasGlobalBanner,
}: HeaderProps) => {

  const {
    onToggleMobileMenu,
    onCloseAllMenus,
    onMouseLeaveHeader,
    onClickMenuButton,
    onClickMenuDrawer,
    onMouseEnterMenuDrawer,
    activeDesktopHeaderMenuIndex,
    isMobileMenuOpen,
    isHeaderScrolled,
  } = useHeader({ hasGlobalBanner });

  return (
    <Fragment>
      {!isMobileMenuOpen && promoBanner}
      <HeaderMobileTakeover
        menu={mobileMenu}
        menuLinks={mobileMenuLinks}
        onClickMenuButton={onClickMenuButton}
      />
      <div className="sticky top-0 z-20">
        <DesktopHeader
          isHeaderScrolled={isHeaderScrolled}
          isMobileMenuOpen={isMobileMenuOpen}
          forceOpaque={forceOpaque}
          onMouseLeaveHeader={onMouseLeaveHeader}
          desktopMenu={desktopMenu}
          logoColumn={
            <LogoColumn
              invert={invert}
              isMobileMenuOpen={isMobileMenuOpen}
              isHeaderScrolled={isHeaderScrolled}
            />
          }
          centerMenuColumn={
            <CenterMenuColumn
              desktopMenu={desktopMenu}
              invert={invert}
              isHeaderScrolled={isHeaderScrolled}
              onCloseAllMenus={onCloseAllMenus}
              onClickMenuDrawer={onClickMenuDrawer}
              onMouseEnterMenuDrawer={onMouseEnterMenuDrawer}
              activeDesktopHeaderMenuIndex={activeDesktopHeaderMenuIndex}
            />
          }
          rightMenuColumn={
            <RightMenuColumn
              desktopMenuLinks={desktopMenuLinks}
              invert={invert}
              isHeaderScrolled={isHeaderScrolled}
              onCloseAllMenus={onCloseAllMenus}
              onClickMenuButton={onClickMenuButton}
              isMobileMenuOpen={isMobileMenuOpen}
              onToggleMobileMenu={onToggleMobileMenu}
            />
          }
        />
      </div>
      {hasGlobalBanner && (
        <BannerWithCta
          title="Find out if your customer service is as good as you think"
          subtitle="Take this 5-question quiz to get your customer service score"
          cta={{
            label: "See my score",
            href: "https://graphite-growth.involve.me/front-quiz",
            target: '_blank',
          }}
        />
      )}
    </Fragment>
  );
};

export default Header;
